import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6f05a259&scoped=true&"
import script from "./Index.vue?vue&type=script&setup=true&lang=js&"
export * from "./Index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=6f05a259&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05a259",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
